<template>
  <TableLayout1 :permissions="['business:category:query']">
    <!-- 搜索表单 -->
    <div ref="QueryFormRef" slot="search-form">
      <el-form ref="searchForm" :model="searchForm"  inline>
        <el-form-item label="名称" prop="name">
          <el-input v-model="searchForm.name" placeholder="请输入名称" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <section>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="refresh">显示全部</el-button>
          <el-button @click="reset">重置</el-button>
        </section>
      </el-form>
    </div>
    <template v-slot:menu>
      <div
        style="width: 100%; height: 50px; background: rgba(242, 242, 242, 1); line-height: 50px; text-align: center; font-size: 14px;">
        跌绊滑风险类型</div>
      <div style="width: 100%; height: calc(100vh - 130px); overflow-y: scroll;">
        <Tree :list="treeList" :alllist="treeList"  :defaultProps="{ name: 'name', status: 'fsStatus', children: 'childList', id: 'id' }"
          @callback="callback" />
      </div>
    </template>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar"  v-if="containPermissions(['business:category:create', 'business:category:delete' ])" >
        <li><el-button type="primary"
                       @click="$refs.operaCategoryWindow.open('新建跌绊滑风险类型', null,categoryList ,searchForm.type,searchForm.parentId)" icon="el-icon-plus"
                       v-permissions="['business:category:create']">新建</el-button></li>
        <li><el-button type="danger" @click="deleteByIdInBatch(true,getfindTreePage)" icon="el-icon-delete" v-permissions="['business:category:delete']">批量删除</el-button></li>
      </ul>
      <el-table  :height="tableHeightNew" v-loading="isWorking.search" :data="tableData.list" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="名称" min-width="100px"></el-table-column>
        <el-table-column prop="parentName" label="父级" min-width="150px"></el-table-column>
        <el-table-column prop="namePath" label="完整路径" min-width="150px"></el-table-column>
        <el-table-column prop="editorName" label="操作人" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="最后操作时间" min-width="150px"></el-table-column>
        <el-table-column fixed="right" v-if="containPermissions(['business:category:update', 'business:category:delete' ])" label="操作" min-width="150">
          <template slot-scope="{row}">
            <el-button type="text" icon="el-icon-edit" @click="$refs.operaCategoryWindow.open('编辑跌绊滑风险类型', row, categoryList,searchForm.type)"  v-permissions="['business:category:update']">编辑</el-button>
            <el-button type="text" icon="el-icon-delete" @click="deleteById(row,true, getfindTreePage)" style="color: red"  v-permissions="['business:category:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination">
      </pagination>
      <OperaCategoryWindow ref="operaCategoryWindow" @success="handlePageChangeDo"/>
    </template>
  </TableLayout1>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout1 from '@/layouts/TableLayout1'
import OperaCategoryWindow from '@/components/business/OperaCategoryWindow'
import Pagination from '@/components/common/Pagination'
import Tree from '@/components/common/Tree'
import { treeList } from '@/api/business/category'
export default {
  name: 'categorySheType',
  extends: BaseTable,
  components: { TableLayout1, Pagination, Tree, OperaCategoryWindow },
  data () {
    return {
      TreeList: [],
      // 搜索
      searchForm: {
        name: '',
        keyword: '',
        type: 1,
        parentId: '',
        isRoot: 1,
        parentIdPath: null
      },
      loading: false,
      heading: false,
      working: false,
      treeList: [],
      categoryList: []
    }
  },
  created () {
    this.config({
      module: '跌绊滑风险类型配置',
      api: '/business/category',
      'field.id': 'id',
      'field.main': 'id'
    })
    // this.search()
    this.getfindTreePage()
  },
  methods: {
    refresh () {
      this.searchForm.parentId = null
      this.searchForm.isRoot = null
      this.getfindTreePage()
      this.handlePageChange()
    },
    handlePageChangeDo () {
      this.searchForm.parentId = null
      this.searchForm.isRoot = 1
      this.getfindTreePage()
      this.handlePageChange()
    },
    // 获取组织树
    getfindTreePage () {
      treeList({ type: this.searchForm.type })
        .then(res => {
          if (res && res.length > 0) {
            res[0].fsStatus = 1
            // var tree= [{id:null, name:'顶级', childList:res,fsStatus:1}]
            this.treeList = res
            this.search()
            this.categoryList = this.getCategoryTree(res)
          }
        })
    },
    getCategoryTree (tree) {
      if (tree == null) {
        return []
      }
      return tree.map(item => {
        const newItem = { ...item }
        if (newItem) {
          newItem.children = newItem.childList
        }
        if (item.children && item.children.length === 0) {
          this.$delete(newItem, 'children')
        } else {
          newItem.children = this.getCategoryTree(newItem.children)
        }
        // newItem.disabled = false
        return newItem
      })
    },
    callback (row) {
      console.log(row)
      this.searchForm.isRoot = null
      this.searchForm.parentId = row.id
      this.searchForm.parentIdPath = row.idPath
      this.search()
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  display: flex;
  align-items: center;

  .box_menu {
    width: 100px;
    height: 100%;
    flex-shrink: 0;
  }

  .box_tab {
    flex: 1;
    height: 100%;
  }
}
</style>
